import { createColumnHelper } from '@tanstack/react-table';

import SimpleTable from '../common/SimpleTable';

import { calculateStatus, formatDateTime } from '@/components/utils/utils';
import { IHaggleEvent } from '@/interfaces/api/haggle-event/IHaggleEvent';

const HagglesTable = ({ haggles }: { haggles: IHaggleEvent[] }) => {
	const columnHelper = createColumnHelper<IHaggleEvent>();

	const columns = [
		columnHelper.accessor('id', {
			cell: (info) => <div className="w-[50px]">{info.getValue()}</div>,
			header: () => <div className="w-[50px]">ID</div>,
		}),
		{
			id: 'status',
			cell: (info: { row: { original: unknown } }) => {
				const haggleEvent = info.row.original as IHaggleEvent;
				return (
					<div className="w-[100px]">
						{calculateStatus(haggleEvent.endDate, haggleEvent.startDate)}
					</div>
				);
			},
			header: () => <div className="w-[100px]">STATUS</div>,
		},
		columnHelper.accessor('startDate', {
			cell: (info) => (
				<div className="w-[200px]">{formatDateTime(info.getValue())}</div>
			),
			header: () => <div className="w-[200px]">START DATE</div>,
		}),
		columnHelper.accessor('endDate', {
			cell: (info) => (
				<div className="w-[200px]">{formatDateTime(info.getValue())}</div>
			),
			header: () => <div className="w-[200px]">END DATE</div>,
		}),
		columnHelper.accessor('chatBots', {
			cell: (info) => {
				const agreementsReached = info
					.getValue()
					.filter((chatBot) => chatBot?.agreement)?.length;
				return (
					<div className="w-[120px] text-center">{`${agreementsReached}/${
						info.getValue()?.length
					}`}</div>
				);
			},
			header: () => <div className="w-[120px] text-center">DEALS/CHATS</div>,
		}),
		columnHelper.accessor('acceptableMargin', {
			cell: (info) => (
				<div className="w-[80px] text-center">{`${info.getValue()} %`}</div>
			),
			header: () => <div className="w-[80px] text-center">MAX. DISCOUNT</div>,
		}),
		columnHelper.accessor('productIds', {
			cell: (info) => (
				<div className="w-[100px] text-right pr-[20px]">{`${
					info.getValue()?.length
				}`}</div>
			),
			header: () => <div className="w-[100px]">PRODUCTS</div>,
		}),
	];
	return (
		<div
			className="flex flex-col items-center border-t border-gray-300 w-full bg-grey-0 border rounded-md"
			data-test="store-haggles-table"
		>
			<SimpleTable collection={haggles || []} columns={columns} />
		</div>
	);
};

export default HagglesTable;
